module.exports = __webpack_public_path__ + "doctor1.7f24c695b9e6ce8ec8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor1.png
// module id = 451
// module chunks = 1